export type Wave1bNavItem = {
    path: string;
    navTitle: string;
    icon?: string;
};

export type Wave1bShellDefinition = {
    id: string;
    title: string;
    subtitle: string;
    icon: string;
    nav: Wave1bNavItem[];
};

export const WAVE1B_SHELLS: Record<string, Wave1bShellDefinition> = {
    dms: {
        id: 'dms',
        title: 'Documents & files',
        subtitle: 'Document library, templates, and file storage.',
        icon: 'heroicons_outline:document-text',
        nav: [
            { path: 'files', navTitle: 'Files', icon: 'heroicons_outline:document-text' },
            { path: 'documents', navTitle: 'Documents', icon: 'heroicons_outline:document-text' },
            { path: 'templates', navTitle: 'Templates', icon: 'heroicons_outline:clipboard-list' },
            { path: 'layouts', navTitle: 'Page layouts', icon: 'heroicons_outline:document-duplicate' },
            { path: 'settings', navTitle: 'Settings', icon: 'heroicons_outline:cog' },
        ],
    },
    mailing: {
        id: 'mailing',
        title: 'Mailing',
        subtitle: 'Inbox, Outlook-style calendar, compose, drafts, and mailboxes.',
        icon: 'heroicons_outline:mail',
        nav: [
            { path: 'inbox', navTitle: 'Inbox', icon: 'heroicons_outline:inbox' },
            { path: 'compose', navTitle: 'Compose', icon: 'heroicons_outline:pencil-alt' },
            { path: 'sent', navTitle: 'Sent', icon: 'heroicons_outline:paper-airplane' },
            { path: 'scheduled-mail', navTitle: 'Scheduled', icon: 'heroicons_outline:clock' },
            { path: 'drafts', navTitle: 'Drafts', icon: 'heroicons_outline:document-text' },
            { path: 'review', navTitle: 'Review queue', icon: 'heroicons_outline:clipboard-check' },
            { path: 'mailboxes', navTitle: 'Mailboxes', icon: 'heroicons_outline:server' },
            { path: 'settings', navTitle: 'Settings', icon: 'heroicons_outline:cog' },
        ],
    },



    profile: {
        id: 'profile',
        title: 'Profile',
        subtitle: 'Account details, security, and notification preferences.',
        icon: 'heroicons_outline:user-circle',
        nav: [
            { path: '', navTitle: 'Overview', icon: 'heroicons_outline:user' },
            { path: 'security', navTitle: 'Security', icon: 'heroicons_outline:shield-check' },
            { path: 'notifications', navTitle: 'Notifications', icon: 'heroicons_outline:bell' },
        ],
    },
    marketing: {
        id: 'marketing',
        title: 'Marketing',
        subtitle: 'Bulk campaigns, templates, and audiences.',
        icon: 'heroicons_outline:sparkles',
        nav: [
            { path: 'campaigns', navTitle: 'Campaigns', icon: 'heroicons_outline:paper-airplane' },
            { path: 'templates', navTitle: 'Templates', icon: 'heroicons_outline:mail' },
            { path: 'audiences', navTitle: 'Audiences', icon: 'heroicons_outline:user-group' },
            { path: 'settings', navTitle: 'Settings', icon: 'heroicons_outline:cog' },
        ],
    },
    campaigns: {
        id: 'campaigns',
        title: 'Campaigns',
        subtitle: 'Social listening, scraper campaigns, and marketing email.',
        icon: 'heroicons_outline:chart-bar',
        nav: [
            { path: '', navTitle: 'Campaigns', icon: 'heroicons_outline:view-list' },
            { path: 'email', navTitle: 'Email', icon: 'heroicons_outline:mail' },
            { path: 'email/lists', navTitle: 'Recipients', icon: 'heroicons_outline:user-group' },
            { path: 'email/templates', navTitle: 'Templates', icon: 'heroicons_outline:document-text' },
            { path: 'market-pulse', navTitle: 'Market Pulse', icon: 'heroicons_outline:chart-bar' },
            { path: 'settings', navTitle: 'Settings', icon: 'heroicons_outline:cog' },
        ],
    },
    tenantAdmin: {
        id: 'tenant-admin',
        title: 'Tenant admin',
        subtitle: 'Users, org structure, and access grants.',
        icon: 'heroicons_outline:office-building',
        nav: [
            { path: 'users', navTitle: 'Users', icon: 'heroicons_outline:users' },
            { path: 'clients', navTitle: 'Clients', icon: 'heroicons_outline:user-group' },
            { path: 'organizations', navTitle: 'Organizations', icon: 'heroicons_outline:office-building' },
            { path: 'branches', navTitle: 'Branches', icon: 'heroicons_outline:collection' },
            { path: 'access', navTitle: 'Access hub', icon: 'heroicons_outline:key' },
        ],
    },
    wiki: {
        id: 'wiki',
        title: 'Wiki',
        subtitle: 'Documentation, processes, and knowledge base.',
        icon: 'heroicons_outline:book-open',
        nav: [
            { path: 'articles', navTitle: 'Articles', icon: 'heroicons_outline:document-text' },
            { path: 'processes', navTitle: 'Processes', icon: 'heroicons_outline:clipboard-list' },
            { path: 'categories', navTitle: 'Categories', icon: 'heroicons_outline:folder' },
            { path: 'settings', navTitle: 'Settings', icon: 'heroicons_outline:cog' },
        ],
    },
    support: {
        id: 'support',
        title: 'Support',
        subtitle: 'Tickets and support configuration.',
        icon: 'heroicons_outline:support',
        nav: [
            { path: '', navTitle: 'Tickets', icon: 'heroicons_outline:ticket' },
            { path: 'project', navTitle: 'Project', icon: 'heroicons_outline:briefcase' },
            { path: 'report', navTitle: 'Report', icon: 'heroicons_outline:chart-bar' },
            { path: 'admin', navTitle: 'Ashcorp pool', icon: 'heroicons_outline:user-group' },
            { path: 'settings', navTitle: 'Settings', icon: 'heroicons_outline:cog' },
        ],
    },
};

export function getWave1bShell(id: string): Wave1bShellDefinition {
    const def = WAVE1B_SHELLS[id];
    if (!def) {
        throw new Error(`Unknown Wave1b shell: ${id}`);
    }
    return def;
}
